module.exports = __webpack_public_path__ + "img/product-03.971057f5.svg";